// ==============================|| THEME CONSTANT ||============================== //

export const APP_DEFAULT_PATH = '/dashboard';
export const DRAWER_WIDTH = 240;
export const MINI_DRAWER_WIDTH = 64;

const config = {
  // Inter (self-hosted through @fontsource-variable/inter – no Google Fonts request)
  fontFamily: `'Inter Variable', 'Inter', 'Public Sans', system-ui, -apple-system, 'Segoe UI', Roboto, Arial, sans-serif`
};

export default config;
